import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      stroke: "#464646",
      "stroke-width": ".5",
      d: "M2.62 6.25c0 .173.062.325.194.456l5.481 5.357q.178.187.45.187a.62.62 0 0 0 .635-.63.65.65 0 0 0-.186-.448L4.162 6.25l5.032-4.922A.66.66 0 0 0 9.38.88.62.62 0 0 0 8.745.25a.62.62 0 0 0-.45.18L2.814 5.794a.61.61 0 0 0-.194.456Z"
    }, null, -1)
  ])))
}
export default { render: render }